// extracted by mini-css-extract-plugin
module.exports = {"container":"product-box-module--container--159Cq","image":"product-box-module--image--1z3iW","title":"product-box-module--title--3-NTE"};